var map = {
	"./img_countdown_cn.png": "DLaQ",
	"./img_countdown_de.png": "eaiq",
	"./img_countdown_en.png": "VW9w",
	"./img_countdown_es.png": "8wDv",
	"./img_countdown_fr.png": "SfRG",
	"./img_countdown_it.png": "s9/K",
	"./img_countdown_jp.png": "RnIP",
	"./img_countdown_pt.png": "ZxmY",
	"./img_countdown_tw.png": "FhYX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AYAG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/christmasSaled-2022 ^\.\/img_countdown_.*\.png$
// module id = AYAG
// module chunks = 1